module.exports = __webpack_public_path__ + "img/missionaries20_2019_7-7-2021.22588aa7.jpg";